import { render, staticRenderFns } from "./StatisticsTable.vue?vue&type=template&id=212cddd7&"
import script from "./StatisticsTable.vue?vue&type=script&lang=js&"
export * from "./StatisticsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports